import React from 'react';

import OptimizelyScripts from '../../components/OptimizelyScripts';
import GlobalStyle from '../GlobalStyle';
import LayoutHead from '../LayoutHead';
import { TMenuItem } from '../Menu/Menu.types';
import { PreviewModeAlert } from '../PreviewModeAlert';
import { Subnav } from '../Subnav';

interface NavComponentProps {
    menu: {
        items: TMenuItem[];
    };
}

interface LayoutProps {
    head: string;
    menu?: {
        items: TMenuItem[];
    };
    preview?: boolean;
    children: React.ReactNode;
    NavComponent?: React.ComponentType<NavComponentProps>;
}

const Layout: React.FC<LayoutProps> = ({
    head,
    menu,
    preview,
    children,
    NavComponent = Subnav,
}) => {
    return (
        <React.Fragment>
            <LayoutHead head={head} preview={preview} />
            <OptimizelyScripts />
            <GlobalStyle />
            {menu && <NavComponent menu={menu} />}
            {preview && <PreviewModeAlert />}
            {children}
        </React.Fragment>
    );
};

export default Layout;
